// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { DioramaHeaderLayout } from '../../dioramas/DioramaHeaderLayout';
import { ArrowButtonLayout } from '../../common/buttons/ArrowButtonLayout';
import { ButtonLargeLayout } from '../../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '7f381381-b92c-42da-b4f7-adde114302cd',
      type: 'Sprite',
      name: 'gradient',
      className: 'dynamicProps_SPL',
      x: -20,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 1.2',
          height: 'height * 1.2'
        }
      }
    },
    {
      id: 'bfa8e251-b6f7-4562-8f6d-fb7656d7d5e4',
      type: 'Container',
      name: 'dioramaSlot',
      className: '',
      x: 0,
      y: 111,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '57dee7c5-bf2b-4865-b28f-579f27caeea2',
      type: 'Layout',
      name: 'ribbon',
      className: '',
      path: 'dioramas/DioramaHeaderLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '88bf17a8-85be-4554-ba93-1a750bb7201b',
      type: 'Container',
      name: 'switchPanel',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '088807eb-10f5-4d45-af02-53b71dcd0d9a',
      type: 'Container',
      name: 'buttonsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '8cf58fd4-9ebc-4a4c-8d92-0d630f482d08',
      type: 'Layout',
      name: 'prevButton',
      className: '',
      path: 'common/buttons/ArrowButtonLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: -300,
      y: 0,
      scale: {
        x: -1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '88bf17a8-85be-4554-ba93-1a750bb7201b'
    },
    {
      id: 'a1173aed-90e6-4173-8a9e-d5c163d945f7',
      type: 'Layout',
      name: 'nextButton',
      className: '',
      path: 'common/buttons/ArrowButtonLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 300,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '88bf17a8-85be-4554-ba93-1a750bb7201b'
    },
    {
      id: 'd3047996-799e-493f-80ea-37f918cad19b',
      type: 'Text',
      name: 'dioramaModeCloseButton_old',
      className: '',
      x: 0,
      y: 223,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'Rectangle',
        x: -5000,
        y: -182,
        width: 10000,
        height: 5000
      },
      text: 'Tap to go back Home',
      localize: true,
      maxWidth: 697,
      maxHeight: 109,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#4c0501',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#4c0501',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '088807eb-10f5-4d45-af02-53b71dcd0d9a'
    },
    {
      id: '81a12d6c-c375-462c-979c-521605a2e86c',
      type: 'Sprite',
      name: 'dioramaModeCloseButton',
      className: '',
      x: 0,
      y: 250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -75,
        y: -75,
        width: 150,
        height: 150
      },
      texture: 'Shop_Close_Button',
      parent: '088807eb-10f5-4d45-af02-53b71dcd0d9a'
    },
    {
      id: 'fa558950-7501-4373-bc0e-b61b1696d1ad',
      type: 'Layout',
      name: 'dioramaShareButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 83,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '088807eb-10f5-4d45-af02-53b71dcd0d9a',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '39d51402-0d08-4eaf-af59-85fc927f0824',
      type: 'Text',
      name: 'shareButtonLabel',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Share',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#0147b1',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fa558950-7501-4373-bc0e-b61b1696d1ad'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  handleResize: false
} as const;

export class DioramaSwitchLayout {
  static raw = raw;
  root!: Container;
  gradient!: Sprite & { data: typeof raw['list'][1]['data'] };
  dioramaSlot!: Container;
  ribbon!: DioramaHeaderLayout;
  switchPanel!: Container;
  buttonsContainer!: Container;
  prevButton!: ArrowButtonLayout;
  nextButton!: ArrowButtonLayout;
  dioramaModeCloseButton_old!: Text;
  dioramaModeCloseButton!: Sprite;
  dioramaShareButton!: ButtonLargeLayout & { data: typeof raw['list'][10]['data'] };
  shareButtonLabel!: Text;
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
